import { useEffect } from 'react'
import { useNavigate } from 'react-router'

export default function AboutIndex() {
	const navigate = useNavigate()

	useEffect(() => {
		const saved = sessionStorage.getItem('about-last-tab')
		void navigate(saved ?? '/about/team', { replace: true })
	}, [navigate])

	return null
}
